import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2mxgvzf8r: FaireProductEntity = {
  token: "p_u2mxgvzf8r",
  type: "product",
  name: "ESSENTIAL WAFFLE DISH TOWELS - SET OF 2",
  brandToken: "b_1y3jfhqfro",
  brandName: "Hawkins New York",
  imageUrl:
    "https://cdn.faire.com/fastly/ac80bedf13eeb52c8cdf99256b59d0c641ab5ec4f7deebeab8b133db982742f4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90cd380345da39f67f67c4cfecdcd0ae43a553235f62ae884bd3a1c166b486d4.jpeg",
    "https://cdn.faire.com/fastly/352655d7553df9cc2089847d7cc8f26d0a8dbb3f41fd526e1d94c5bf35c83d5b.jpeg",
    "https://cdn.faire.com/fastly/4ae5e0f0539fee90e0ad55f129133b1ef60a1d74a2a125eca4e83b9752740c19.jpeg",
    "https://cdn.faire.com/fastly/0854ef86d6c54886a3bd5a323ca5fefc83ade9b7931e1ad16d2b948a5e2cec1a.jpeg",
    "https://cdn.faire.com/fastly/59da1a84fc847402b153b28098b7e02538280de5edf682dbc63759085d1a4ced.jpeg",
    "https://cdn.faire.com/fastly/7c028f7381fc69d253db9a658a2e109ffd897e17438d2b439cd01c0b20f8a3cf.jpeg",
    "https://cdn.faire.com/fastly/ec73842dda1491a7b8a936c6ecf2b0fa3af4db7362aca79df79abea128968c62.jpeg",
    "https://cdn.faire.com/fastly/af5b6c9c180e3e67368431d970c157e2bddb379f50f868b4879ccb2fff7303e8.jpeg",
    "https://cdn.faire.com/fastly/7f16c72f3b8a5edc624d623282ff40aef79e7e49ddefde24580fd3fc90944ab2.jpeg",
    "https://cdn.faire.com/fastly/b0cf89b0656b27c0948b4588c33cc37366b53d75389cd12998c59d98542eaa13.jpeg",
    "https://cdn.faire.com/fastly/8735e33f069f342dcd00a9a10cf8005a82b2a327288ac6cfc689c0e4029a5a51.jpeg",
    "https://cdn.faire.com/fastly/79368524dc04b4fbd0786c531cbf0fe36e4090434f1513302b0429cd53db131e.jpeg",
  ],
  priceDollars: 16,
  description:
    '\nDISH IT OUT\n\n\n * A set of 2 soft waffle weave kitchen towels in complementary shades \n * Comes in  Terracotta/Peacock  and additional color sets \n * Oeko-Tex Standard 100 certified \n * Super absorbent, quick to dry \n * You\'ll be psyched to reach for them again and again\n\n\n\nSIZE: \n29"L x 21.5"W\n\nDETAILS:\nMaterial: Cotton\nMade in Portugal\n\nCARE: \nMachine wash cold water, tumble dry low + do not bleach.\n\n\n',
  tags: [],
  msrpDollars: 32,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:09.820Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
